jQuery(document).ready(function(){
    function showGenre(bloc, code) {
        bloc.find(".btn, .link").removeClass('active');
        bloc.find('.btn[value="' + code + '"], .link.' + code).addClass('active');
        bloc.find("select").val(code);
        jQuery.ajax({
            url: Routing.generate('ajax_get_film_random_by_genre', {genre: code})
        }).done(function (data) {
            bloc.find(".movies-genres").html(data);
        });
    }

    jQuery(".block-home-genre .btn").click(function() {
        showGenre(jQuery(this).parents('.block-home-genre'), jQuery(this).val());
    });

    jQuery(".block-home-genre select").change(function() {
        showGenre(jQuery(this).parents('.block-home-genre'), jQuery(this).val());
    });

});


